require('./lib/angular.min.js');
export const angular = window.angular;
